import React from 'react';
import '../App.css';
import MessageTemplate from './MessageTemplate';

const ConnectionsList = ({ connections, company, showAll, onToggleShow, jobTitle }) => {
  if (!connections || connections.length === 0) return null;

  const displayConnections = showAll ? connections : connections.slice(0, 3);

  return (
    <div className="connections-section">
      <h3>Your Connections at {company}</h3>
      <div className="connections-grid">
        {displayConnections.map((connection, index) => (
          <div key={index} className="connection-card">
            <div className="connection-header">
              <div className="connection-name">
                {connection.firstName} {connection.lastName}
              </div>
            </div>
            <div className="connection-position">{connection.position}</div>
            <div className="action-row">
              <a 
                href={connection.profileUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="connection-link"
              >
                View Profile
              </a>
              <MessageTemplate 
                connection={connection}
                jobTitle={jobTitle}
                company={company}
              />
            </div>
          </div>
        ))}
      </div>
      {connections.length > 3 && (
        <button 
          onClick={onToggleShow}
          style={{
            backgroundColor: 'black',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            padding: '8px 16px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'block',
            margin: '0 auto'
          }}
        >
          {showAll ? 'Show Less' : `Show ${connections.length - 3} More`}
        </button>
      )}
    </div>
  );
};

export default ConnectionsList;
